import { render, staticRenderFns } from "./Loteria.vue?vue&type=template&id=78811da6&scoped=true&"
import script from "./Loteria.vue?vue&type=script&lang=js&"
export * from "./Loteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78811da6",
  null
  
)

export default component.exports